<form (submit)="submit(form)" [formGroup]="form">
	<h1 mat-dialog-title>{{ data?.title || 'Send Email' }}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start">
			<app-email-input-with-chips
				[label]="'Email Recipients'"
				[parentForm]="form"
				[placeholder]="'Enter email address'">
			</app-email-input-with-chips>
			<mat-form-field fxLayout="column" fxLayoutAlign="stretch">
				<mat-label>Subject</mat-label>
				<input [formControlName]="'subject'" matInput/>
				<mat-error>
					Subject is required
				</mat-error>
			</mat-form-field>
			<mat-form-field fxLayout="column" fxLayoutAlign="stretch">
				<mat-label>Message</mat-label>
				<textarea [formControlName]="'message'" mat-autosize matInput></textarea>
				<mat-error>
					Message is required
				</mat-error>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			Cancel
		</button>
		<button [color]="'primary'" mat-raised-button type="submit">
			Send
		</button>
	</mat-dialog-actions>
</form>